import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Douche = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.19 82.96">
  <G fill={color}>
    <Path d="M20.97,9.97l-.33-7.11C20.56,1.2,19.17-.04,17.5,0c-1.66.08-2.93,1.48-2.86,3.14l.32,6.87C6.48,11.43,0,18.53,0,27.07c0,1.66,1.34,3,3,3h30.19c1.66,0,3-1.34,3-3,0-8.62-6.61-15.78-15.22-17.1Z"/>
    <Path d="M7.43,35.58c-1.66,0-3,1.34-3,3v10.05c0,1.66,1.34,3,3,3s3-1.34,3-3v-10.05c0-1.66-1.34-3-3-3Z"/>
    <Path d="M7.43,57.62c-1.66,0-3,1.34-3,3v19.34c0,1.66,1.34,3,3,3s3-1.34,3-3v-19.34c0-1.66-1.34-3-3-3Z"/>
    <Path d="M28.31,66.91c-1.66,0-3,1.34-3,3v10.05c0,1.66,1.34,3,3,3s3-1.34,3-3v-10.05c0-1.66-1.34-3-3-3Z"/>
    <Path d="M28.31,35.58c-1.66,0-3,1.34-3,3v19.34c0,1.66,1.34,3,3,3s3-1.34,3-3v-19.34c0-1.66-1.34-3-3-3Z"/>
    <Path d="M17.87,43c-1.66,0-3,1.34-3,3v19.34c0,1.66,1.34,3,3,3s3-1.34,3-3v-19.34c0-1.66-1.34-3-3-3Z"/>
  </G>
</Svg>
);
};

export default Douche;
